import React from 'react';
import "./App.css";
import Movie from "./Movie";
import { useState } from 'react';
import New from './New';

function Intro() {
  const [inputList, setInputList] = useState(false);

 const hgfc=()=>{
  setInputList(true);
  setInputList((<Movie/>))
 
 }
    return (
    <>

  {inputList === false ? (
    <div className='Login-component' > 
  <div className='btn'>
  <New/>
    <button className='btni' onClick={hgfc}>Get Started</button>
   {inputList}
  </div>
</div>
  ):(
<Movie/>
  )
  }

    </>

   
       
    );
}

export default Intro;